import type { FC, FormEvent } from 'react';
import React, { useState } from 'react';

import styled from '@emotion/styled';

import { COLORS, mq } from '@clutter/clean';

import { ServiceSelectorModal } from '@shared/service_selector/service_selector_modal';

const PageCTAButton = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  color: ${COLORS.cloud};
  background: ${COLORS.tealPrimary};
  display: inline-flex;
  padding: 18px 36px;
  height: 56px;
  border-radius: 28px;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  line-height: 120%;

  ${mq({
    width: ['100%', '224px'],
    fontFamily: ['"Basier Square"', undefined],
    fontFeatureSettings: ["'liga' off, 'clig' off", undefined],
  })}
`;

export const PageCTA: FC<{
  id: string;
  container: string;
  label: string;
}> = ({ id, container, label }) => {
  const [open, setOpen] = useState(false);

  const onClick = (event: FormEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setOpen((prev) => !prev);
  };

  return (
    <>
      <PageCTAButton type="button" onClick={onClick}>
        {label}
      </PageCTAButton>
      <ServiceSelectorModal
        isOpen={open}
        onClose={() => setOpen(false)}
        id={id}
        wtConfig={{
          container,
          label,
        }}
      />
    </>
  );
};
